import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";
import { useQuery } from "@tanstack/react-query";
import { adminFetchCompanyReports } from "../api/report.api";
import { ReportingCycleEnum } from "../api/models/reportingCycle.models";

interface UseReportsProps {
  companyId: number | null;
  organizationId?: number | null | undefined;
  cycle?: ReportingCycleEnum;
  invoiceNumber?: string;
}

const useAdminReports = ({
  companyId,
  organizationId,
  cycle,
  invoiceNumber,
}: UseReportsProps) => {
  const [bearerToken] = useUIStore(
    useShallow((state: UIState) => [state.bearerToken]),
  );

  const { data: reportsData, isLoading: isLoadingReports } = useQuery({
    queryKey: ["adminReports", companyId, organizationId, cycle, invoiceNumber],
    queryFn: () =>
      adminFetchCompanyReports(
        {
          companyId: companyId as number,
          organizationId: organizationId as number | undefined,
          cycle,
          invoiceNumber,
          take: 1000,
        },
        bearerToken,
      ),
    enabled: !!companyId,
  });

  return {
    reportsData,
    isLoadingReports,
  };
};

export default useAdminReports;
